/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_No_ContactInputs */



/**
* | output |
* | --- |
* | "No contact details shared." |
*
* @param {User_Detail_No_ContactInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_no_contact = /** @type {((inputs?: User_Detail_No_ContactInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_No_ContactInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune coordonnée partagée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No ha compartido datos de contacto.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum contato compartilhado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun contatto condiviso.")
	return /** @type {LocalizedString} */ ("No contact details shared.")
});